import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Tooltip, SvgIcon, IconButton } from '@material-ui/core';
import { updatesRoute } from '../../routes';

const handleClick = (history, rowData) => {
  if (rowData && rowData.status === 'UNPUBLISHED') {
    return;
  }
  history.push(updatesRoute());
};

const UpdatesIcon = ({ message, rowData }) => {
  const history = useHistory();

  return (
    <Tooltip title={message}>
      <IconButton onClick={() => handleClick(history, rowData)}>
        <SvgIcon>
          <path d="M 12 22 c 1.1 0 2 -0.9 2 -2 h -4 c 0 1.1 0.89 2 2 2 Z m 6 -6 v -5 c 0 -3.07 -1.64 -5.64 -4.5 -6.32 V 4 c 0 -0.83 -0.67 -1.5 -1.5 -1.5 s -1.5 0.67 -1.5 1.5 v 0.68 C 7.63 5.36 6 7.92 6 11 v 5 l -2 2 v 1 h 16 v -1 l -2 -2 Z" />
        </SvgIcon>
      </IconButton>
    </Tooltip>
  );
};

UpdatesIcon.propTypes = {
  message: PropTypes.string.isRequired
};

export default UpdatesIcon;
